import { gql } from '@apollo/client';

/**
 * UPDATE_STATEMENT_DELIVERY_MUTATION
 *
 * Updates the statement mailing delivery type for a customer's smartcard statements.
 *
 * @param customerId   - The customer's numeric ID (currentCustomer.id)
 * @param deliveryType - StatementMailingDeliveryType enum: EMAIL_DISPATCH | PAPER_DISPATCH | NONE
 */
export const UPDATE_STATEMENT_DELIVERY_MUTATION = gql`
	mutation UpdateStatementDelivery($customerId: Int!, $deliveryType: StatementMailingDeliveryType!) {
		updateStatementDelivery(
			input: {
				statementDelivery: {
					customerId: $customerId
					deliveryType: $deliveryType
				}
			}
		) {
			statementDelivery {
				deliveryType {
					id
					name
				}
			}
		}
	}
`;

/**
 * UPDATE_INVOICE_DELIVERY_MUTATION
 *
 * Updates the invoice mailing delivery type for a customer's credit card invoices.
 *
 * @param customerId   - The customer's numeric ID (currentCustomer.id)
 * @param deliveryType - InvoiceMailingDeliveryType enum: EMAIL_DISPATCH | PAPER_DISPATCH | NONE
 */
export const UPDATE_INVOICE_DELIVERY_MUTATION = gql`
	mutation UpdateInvoiceDelivery($customerId: Int!, $deliveryType: InvoiceMailingDeliveryType!) {
		updateInvoiceDelivery(
			input: {
				invoiceDelivery: {
					customerId: $customerId
					deliveryType: $deliveryType
				}
			}
		) {
			invoiceDelivery {
				deliveryType {
					id
					name
				}
			}
		}
	}
`;

/**
 * UPDATE_CUSTOMER_FROZEN_MUTATION
 *
 * Updates the frozen status of a customer account.
 * Used to immediately freeze/unfreeze a customer when they request account deletion.
 *
 * @param id     - The customer's numeric ID (currentCustomer.id)
 * @param is     - true = freeze the account, false = unfreeze
 * @param reason - Human-readable reason for the status change
 */
export const UPDATE_CUSTOMER_FROZEN_MUTATION = gql`
	mutation UpdateCustomerFrozen($id: Int!, $is: Boolean!, $reason: String!) {
		updateCustomerFrozen(
			input: {
				frozen: { is: $is, reason: $reason }
				id: $id
			}
		) {
			customer {
				customerNumber
				id
				isCompany
				lastName
				name
			}
		}
	}
`;

/**
 * UPDATE_AUTOGIRO_MUTATION
 *
 * Connects or updates autogiro (direct debit) for a customer.
 *
 * @param approved                 - Whether autogiro is approved
 * @param customerId               - The customer's numeric ID
 * @param requestedAccountNumber   - The bank account number to debit
 * @param requestedClearingNumber  - The bank clearing number
 */
export const UPDATE_AUTOGIRO_MUTATION = gql`
    mutation UpdateAutogiro(
        $approved: Boolean!
        $customerId: Int!
        $requestedAccountNumber: String
        $requestedClearingNumber: String
    ) {
        updateAutogiro(
            input: {
                approved: $approved
                customerId: $customerId
                requestedAccountNumber: $requestedAccountNumber
                requestedClearingNumber: $requestedClearingNumber
            }
        ) {
            autogiro {
                accountNumber
                approved
                changeRequested
                changeRequestedAt
                clearingNumber
            }
        }
    }
`;
